import { convertToURLFormat } from "./convertToURLFormat"

export const createEntityUrl = (federationId: string, entityDisplayName: string, entityId: string) => {
  return '/federations/' + federationId + '/entity/' + convertToURLFormat(entityDisplayName) + '?entityId=' + entityId
}